import React, { useEffect, useRef, useState } from "react";
import Dashboardmenus from "./Dashboardmenus";
import { handleToggleCollapse } from "../../common/Collapsfunction";
import { authcallApi, callApi } from "../../common/API/Api";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useNotification } from "../../common/Notification";
import CommonDropdown from "../../common/CommonDropdown";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
import {
  adjustToTimezone,
  convertToServerTime,
  getServerTime,
  gettimezoneprefrence,
} from "./commonmodal/Getservertime";
import Pagination from "./commonmodal/Pagination";
import ServerDatePicker from "./commonmodal/ServerDatePicker";
import { formatDisplayDate } from "./commonmodal/CommonHistorydate";
import Commonloader from "../../common/Commonloader";
import { getBaseUrl } from "../../common/BaseUrl";
const Supportdashboard = () => {
  const [updatetimezone, setUpdateTimezone] = useState();
  const { showNotification } = useNotification();
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [opencount, setOpencount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotlepages] = useState();
  const [itemsPerPage, setItemperpage] = useState();
  const [currentPagelist, setCurrentPagelist] = useState(1);
  const [totalPageslist, setTotlepageslist] = useState();
  const [itemsPerPagelist, setItemperpagelist] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  let base_url = getBaseUrl();
  const fileInputRef = useRef(null);
  const [collapseshow, setCollapseshow] = useState();
  const [searchdepodit, setSearchdeposit] = useState("");
  const [wallethistory, setWallehistory] = useState([]);
  const [loader, setLoader] = useState(true);
  const [createrequst, setCreaterequest] = useState({
    email: "",
    category: "",
    message: "",
    attachment: "",
  });
  const [requestvalid, setRequestvalid] = useState();
  const [supportlist, setSupprotlist] = useState([]);
  const [closesupportlist, setCloseSupportlist] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const location = useLocation();
  const state = location.state;
  const requestdata = (key, value) => {
    setCreaterequest((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const createrequestvalid = (createrequstdata) => {
    let returnvalue = true;
    // if (!createrequstdata?.email) {
    //   setRequestvalid((state) => ({
    //     ...state,
    //     email: "Enter Email",
    //   }));
    //   returnvalue = false;
    // } else {
    //   setRequestvalid((state) => ({
    //     ...state,
    //     email: "",
    //   }));
    // }
    if (!createrequstdata?.category) {
      setRequestvalid((state) => ({
        ...state,
        category: "Enter category",
      }));
      returnvalue = false;
    } else {
      setRequestvalid((state) => ({
        ...state,
        category: "",
      }));
    }
    if (
      createrequstdata?.category === "Deposits" ||
      createrequst?.category === "Withdrawals"
    ) {
      if (!selectedTransaction?.payment_transaction?.transaction_id) {
        setRequestvalid((state) => ({
          ...state,
          transaction_id: "Select transaction_id",
        }));
        returnvalue = false;
      } else {
        setRequestvalid((state) => ({
          ...state,
          transaction_id: "",
        }));
      }
    }
    if (!createrequstdata?.message) {
      setRequestvalid((state) => ({
        ...state,
        message: "Enter message",
      }));
      returnvalue = false;
    } else {
      setRequestvalid((state) => ({
        ...state,
        message: "",
      }));
    }
    if (returnvalue) {
      createsupport(createrequstdata);
    }
  };

  const createsupport = async (createrequstdata) => {
    try {
      let postdata = {
        category: createrequstdata?.category,
        message: createrequstdata?.message,
        transaction_id:
          createrequstdata?.category === "Deposits" ||
          createrequst?.category === "Withdrawals"
            ? selectedTransaction?.payment_transaction?.transaction_id
            : "",
        attachment: createrequstdata?.attachment,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(
        formData,
        `api/create-support-ticket`,
        "POST",
      );
      if (res?.data?.success) {
        setSelectedTransaction(null);
        setSearchdeposit("");
        setCurrentPage(1);
        showNotification(res?.data?.message, "success");
        getsupport();
        navigate(`${base_url}supportdashboard`, {
          state: { from: "my_requests" },
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setCreaterequest({
          email: "",
          category: "",
          message: "",
        });
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsupport = async () => {
    try {
      setLoader(true);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket?type=open`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          setOpencount(res?.data?.data.length);
          setSupprotlist(res?.data?.data);
        } else {
          setOpencount(0);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoader(false);
    }
  };
  const getsupportclose = async (page) => {
    try {
      // setLoader(true);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket?type=close&page=${page ? page : 1}`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          setCloseSupportlist(res?.data?.data);
          setTotlepageslist(res?.data?.total_count);
          setItemperpagelist(res?.data?.limit);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      // setLoader(false);
    }
  };
  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        setUserDetails(res?.data?.data);
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    getsupport();
    userdetails();
    getsupportclose();
  }, []);
  let langcode = JSON.parse(localStorage.getItem("langcode"));
  const [faqdata, setFaqdata] = useState([]);
  const [faqcatagarydata, setFaqcatagarydata] = useState();
  const getsupportfaq = async (langcode) => {
    try {
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-support?lang=${langcode?.Code ? langcode?.Code : "en"}`,
        "GET",
      );
      if (res?.data?.success) {
        setFaqdata(res?.data?.data);
        setFaqcatagarydata({
          data: res?.data?.data[0],
          key: 0,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsupportfaq(langcode);
  }, []);
  const transactionHistory = async (search, page) => {
    try {
      let postdata = {
        start_date: formatDisplayDate(startDate),
        end_date: formatDisplayDate(endDate),
        action:
          createrequst?.category === "Deposits" ? "Deposit" : "Withdrawal",
        page: page ? page : currentPage ? currentPage : 1,
        search: search ? search : "",
      };
      if (!postdata?.start_date && !postdata?.end_date) {
        const today = new Date();
        const startdate = new Date(today);

        postdata = {
          start_date: formatDisplayDate(
            startdate.setDate(startdate.getDate() - 29),
          ),
          end_date: formatDisplayDate(today),
          action:
            createrequst?.category === "Deposits" ? "Deposit" : "Withdrawal",
          page: page ? page : currentPage ? currentPage : 1,
          search: search ? search : "",
        };
      }
      let res = await authcallApi(
        postdata,
        `api/wallethistory?${
          postdata?.start_date ? `start_date=${postdata.start_date}&` : ""
        }${postdata?.end_date ? `end_date=${postdata.end_date}&` : ""}${
          postdata?.action ? `action=${postdata.action}&` : ""
        }account_type=real&usertype=real&page=${
          postdata?.page
        }&limit=${20}&search=${postdata?.search}`,
        "GET",
      );
      if (res?.data?.success) {
        setSearchdeposit(postdata?.search);
        setCurrentPage(res?.data?.current_page);
        setTotlepages(res?.data?.total_count);
        setItemperpage(res?.data?.limit);
        setWallehistory(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (
      createrequst?.category === "Deposits" ||
      createrequst?.category === "Withdrawals"
    ) {
      transactionHistory(searchdepodit);
    }
  }, [currentPage, startDate, endDate, createrequst?.category]);
  const uploadimage = async (image) => {
    console.log(image.target.files[0]?.name, "image");
    const file = image.target.files[0];
    let obj = { image: file, type: "support" };
    try {
      const formData = new FormData();
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          formData.append(key, obj[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/setimage`, "POST");
      if (res?.data?.success) {
        requestdata("attachment", res?.data?.path);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const handleClick = (ticket_id, id) => {
    navigate(`${base_url}supportdashboard/${ticket_id}/${id}`);
  };
  const handleselect = (value) => {
    setSelectedTransaction(null);
    setSearchdeposit("");
    setCurrentPage(1);
    requestdata("category", value);
  };
  const categoryoptcion = [
    "General Questions",
    "Account Issues",
    "Deposits",
    "Withdrawals",
    "Trading",
    "Other",
  ];
  const getimezone = async () => {
    const timezonePref = await gettimezoneprefrence();
    setUpdateTimezone(timezonePref);
  };
  useEffect(() => {
    getimezone();
  }, []);
  useEffect(() => {
    if (!location.state) {
      navigate(location.pathname, {
        replace: true,
        state: { from: "my_requests" },
      });
    }
  }, [location, navigate]);
  const handleCloseModal = () => {
    const modalEl = document.getElementById("transactionIdmodal");
    const modal = window.bootstrap.Modal.getInstance(modalEl);
    modal.hide();
    setCurrentPage(1);
    setSearchdeposit("");
  };
  const fetchServerTime = async () => {
    const data = await getServerTime(); 
    const timezonePref = await gettimezoneprefrence();
    if (data?.success) {
      const adjustedTimestamp = await adjustToTimezone(
        data.server_time,
        timezonePref.time,
      );
      return {
        ...data,
        adjustedTimestamp,
        timezonePref,
      };
    }
    return data;
  };
  const handleDateChange = async (start, end) => {
    const timezonePref = await gettimezoneprefrence();
    let updatedstart = convertToServerTime(start, timezonePref.time);
    let updatedend = convertToServerTime(end, timezonePref.time);
    setEndDate(updatedend);
    setStartDate(updatedstart);
  };

  const goToPage = (page) => {
    const totalPagesall = Math.ceil(totalPages / itemsPerPage);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPage(page);
  };
  const getMessage = (msg) => {
    try {
      let parsed = JSON.parse(msg);
      if (Array.isArray(parsed)) {
        return parsed[parsed.length - 1];
      }
      return msg;
    } catch (e) {
      return msg;
    }
  };
  const goToPagesuppportlist = (page) => {
    const totalPagesall = Math.ceil(totalPageslist / itemsPerPagelist);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPagelist(page);
    getsupportclose(page);
  };

  return (
    <React.Fragment>
      <Dashboardmenus />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12 dw mb-3">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "my_requests" && "active"
                      }`}
                      to={`${base_url}supportdashboard`}
                      state={{ from: "my_requests" }}
                      // className={`nav-link ${
                      //   activeTab === "myRequests" ? "active" : ""
                      // }`}
                      id="deposit-tab"

                      // data-bs-toggle="tab"
                      // data-bs-target="#deposit"
                      // type="button"
                      // role="tab"
                      // aria-controls="deposit"
                      // aria-selected={activeTab === "myRequests"}
                      // onClick={() => setActiveTab("myRequests")}
                    >
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.81509 26.87C9.71509 26.86 9.59509 26.86 9.48509 26.87C7.10509 26.79 5.21509 24.84 5.21509 22.44C5.21509 19.99 7.19509 18 9.65509 18C12.1051 18 14.0951 19.99 14.0951 22.44C14.0851 24.84 12.1951 26.79 9.81509 26.87Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4.815 30.56C2.395 32.18 2.395 34.82 4.815 36.43C7.565 38.27 12.075 38.27 14.825 36.43C17.245 34.81 17.245 32.17 14.825 30.56C12.085 28.73 7.575 28.73 4.815 30.56Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M32.655 5H24.655C20.655 5 18.655 7 18.655 11V24C18.655 24.55 19.105 25 19.655 25H32.655C36.655 25 38.655 23 38.655 19V11C38.655 7 36.655 5 32.655 5Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M23.655 12.5H33.655"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M23.655 17.5H30.655"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {t("My requests")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "create_request" && "active"
                      }`}
                      to={`${base_url}supportdashboard`}
                      state={{ from: "create_request" }}
                      // className={`nav-link ${
                      //   activeTab === "createRequest" ? "active" : ""
                      // }`}
                      id="withdrawal-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#withdrawal"
                      // type="button"
                      // role="tab"
                      // aria-controls="withdrawal"
                      // aria-selected={activeTab === "createRequest"}
                      // onClick={() => setActiveTab("createRequest")}
                    >
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.81509 26.87C9.71509 26.86 9.59509 26.86 9.48509 26.87C7.10509 26.79 5.21509 24.84 5.21509 22.44C5.21509 19.99 7.19509 18 9.65509 18C12.1051 18 14.0951 19.99 14.0951 22.44C14.0851 24.84 12.1951 26.79 9.81509 26.87Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4.815 30.56C2.395 32.18 2.395 34.82 4.815 36.43C7.565 38.27 12.075 38.27 14.825 36.43C17.245 34.81 17.245 32.17 14.825 30.56C12.085 28.73 7.575 28.73 4.815 30.56Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M32.655 5H24.655C20.655 5 18.655 7 18.655 11V24C18.655 24.55 19.105 25 19.655 25H32.655C36.655 25 38.655 23 38.655 19V11C38.655 7 36.655 5 32.655 5Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M25.155 15H32.155"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M28.655 18.5V11.5"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {t("Create request")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "faq" && "active"
                      }`}
                      to={`${base_url}supportdashboard`}
                      state={{ from: "faq" }}
                      id="cashback-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#cashback"
                      // type="button"
                      // role="tab"
                      // aria-controls="cashback"
                      // aria-selected={activeTab === "faq"}
                      // onClick={() => setActiveTab("faq")}
                    >
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_3228_1365)">
                          <path
                            d="M17.48 16.5067C17.9066 16.0534 18.4 15.6934 18.9733 15.4667C19.5333 15.2401 20.16 15.1467 20.7733 15.1867C21.4 15.2401 21.9867 15.4134 22.52 15.7201C23.0534 16.0267 23.5067 16.4667 23.84 16.9734C24.1733 17.4934 24.4 18.0667 24.4933 18.6934C24.56 19.2934 24.52 19.9334 24.32 20.5067C24.1467 21.0801 23.8133 21.6401 23.3867 22.0534C22.9467 22.4934 22.4267 22.8267 21.84 23.0401"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M27.6667 9H14.3333C11.3878 9 9 11.3878 9 14.3333V27.6667C9 30.6122 11.3878 33 14.3333 33H27.6667C30.6122 33 33 30.6122 33 27.6667V14.3333C33 11.3878 30.6122 9 27.6667 9Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21 27H21.0133"
                            stroke="#292D32"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3228_1365">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(5 5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      {t("FAQ")}
                    </Link>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className={`tab-pane fade ${
                      state?.from === "my_requests" ? "show active" : ""
                    }`}
                    id="deposit"
                    role="tabpanel"
                    aria-labelledby="deposit-tab"
                  >
                    {/* <!-- <div className="col-md-12">   <h4 className="card_title">Submit a New Support Request</h4></div> --> */}

                    {/* <!-- <div className="deposit_box cardBox mb-4"> --> */}
                    <div className="cardBox mb-4">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="">
                            <h4 className="card_title">
                              {t("My Open Support Requests")}
                            </h4>
                            <div className="table-responsive">
                              <table
                                className="table table-dark table-striped"
                                data-bs-theme="dark"
                              >
                                <thead>
                                  <tr>
                                    <th>{t("Ticket ID")}</th>
                                    <th>{t("Status")}</th>
                                    <th>{t("Category")}</th>
                                    <th>{t("Message")}</th>
                                    <th>{t("Last Update")}</th>
                                    <th>{t("Date")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loader ? (
                                    <tr>
                                      <td
                                        colSpan="6"
                                        className="loaderparentpositaion"
                                      >
                                        <Commonloader show={true} />
                                      </td>
                                    </tr>
                                  ) : supportlist?.length ? (
                                    supportlist.map((result, key) => {
                                      return (
                                        <tr
                                          key={key}
                                          onClick={() =>
                                            handleClick(
                                              result?.ticket_id,
                                              result?.id,
                                            )
                                          }
                                          style={{
                                            cursor: "pointer",
                                            borderBottom: "2px solid #0080004f",
                                            borderTop: "2px solid #0080004f",
                                            boxShadow: "0 0 10px #0080004f",
                                          }}
                                        >
                                          <td>{result?.ticket_id}</td>
                                          <td>
                                            <span
                                              className={`badge ${
                                                result?.status === "answered"
                                                  ? "bg-success"
                                                  : result?.status === "open" ||
                                                      result?.status ===
                                                        "under consideration"
                                                    ? "bg-warning"
                                                    : "bg-info"
                                              }`}
                                            >
                                              {result?.status ===
                                              "under consideration"
                                                ? "OPEN"
                                                : result?.status?.toUpperCase()}
                                            </span>
                                          </td>
                                          <td>{result?.category}</td>
                                          <td
                                            style={{
                                              maxWidth: "300px",
                                              whiteSpace: "break-spaces",
                                            }}
                                          >
                                            {getMessage(result?.message)}
                                          </td>
                                          <td>{result?.last_updated}</td>
                                          <td>
                                            {" "}
                                            {
                                              convertLocalToUTCFormatted(
                                                result?.date,
                                                updatetimezone,
                                              )?.datetime
                                            }
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr className="no_data_table">
                                      <td colSpan={6} className="text-center">
                                        {t("No Data Found")}
                                      </td>
                                    </tr>
                                  )}

                                  {/* <!-- Additional rows can be added here --> */}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="cardBox">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="">
                            <h4 className="card_title">
                              {t("My Close Support Requests")}
                            </h4>
                            <div className="table-responsive">
                              <table
                                className="table table-dark table-striped"
                                data-bs-theme="dark"
                              >
                                <thead>
                                  <tr>
                                    <th>{t("Ticket ID")}</th>
                                    <th>{t("Date")}</th>
                                    <th>{t("Category")}</th>
                                    <th>{t("Message")}</th>
                                    <th>{t("Last Update")}</th>
                                    <th>{t("Status")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* <!-- Archived requests can be listed here --> */}
                                  {loader ? (
                                    <tr>
                                      <td
                                        colSpan="6"
                                        className="loaderparentpositaion"
                                      >
                                        <Commonloader show={true} />
                                      </td>
                                    </tr>
                                  ) : closesupportlist?.length ? (
                                    closesupportlist.map((result, key) => {
                                      return (
                                        <tr
                                          key={key}
                                          onClick={() =>
                                            handleClick(
                                              result?.ticket_id,
                                              result?.id,
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <td>{result?.ticket_id}</td>
                                          <td>
                                            {
                                              convertLocalToUTCFormatted(
                                                result?.date,
                                                updatetimezone,
                                              )?.datetime
                                            }
                                          </td>
                                          <td>{result?.category}</td>
                                          <td
                                            style={{
                                              maxWidth: "300px",
                                              whiteSpace: "break-spaces",
                                            }}
                                          >
                                            {getMessage(result?.message)}
                                          </td>
                                          <td>{result?.last_updated}</td>
                                          <td>
                                            <span className="badge bg-danger">
                                              {result?.status?.toUpperCase()}
                                            </span>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr className="no_data_table">
                                      <td colSpan={6} className="text-center">
                                        {t("No Data Found")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <Pagination
                              totalItems={totalPageslist || 20}
                              itemsPerPage={itemsPerPagelist || 20}
                              currentPage={currentPagelist || 1}
                              goToPage={goToPagesuppportlist}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      state?.from === "create_request" ? "show active" : ""
                    }`}
                    id="withdrawal"
                    role="tabpanel"
                    aria-labelledby="withdrawal-tab"
                  >
                    <div className="create-request-box">
                      <div className="row">
                        <div className="col-md-12">
                          <h4 className="card_title"> {t("Create Request")}</h4>
                        </div>

                        <div className="col-md-12">
                          <div className="cardBox">
                            <h4 className="card_title">
                              {t("Submit a New Support Request")}
                            </h4>
                            <p>
                              {t(
                                "Complete the provided forms to submit your request. Fields marked with * are required.",
                              )}
                            </p>
                            <form className="w_form">
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3">
                                    <label>{t("Your email address")} *</label>
                                    <input
                                      disabled
                                      onChange={(e) =>
                                        requestdata(
                                          "email",
                                          userDetails?.user?.email,
                                        )
                                      }
                                      value={userDetails?.user?.email}
                                      type="email"
                                      name="email"
                                      className={
                                        requestvalid?.email
                                          ? "border-danger form-control"
                                          : "form-control"
                                      }
                                      placeholder={t("Enter your Email")}
                                      required
                                    />
                                    {requestvalid?.email ? (
                                      <p className="text-danger">
                                        {requestvalid?.email}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3">
                                    <label>{t("Category")} *</label>

                                    <CommonDropdown
                                      label={
                                        createrequst?.category ||
                                        "select category"
                                      }
                                      options={categoryoptcion}
                                      onSelect={(val) => handleselect(val)}
                                    />
                                    {requestvalid?.category ? (
                                      <p className="text-danger">
                                        {requestvalid?.category}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                {(createrequst?.category === "Deposits" ||
                                  createrequst?.category === "Withdrawals") &&
                                  !selectedTransaction?.payment_transaction
                                    ?.transaction_id && (
                                    <div className="col-lg-6 col-md-6">
                                      <div className="mb-3">
                                        <label>{t("Select transaction")}</label>
                                        <button
                                          className={
                                            requestvalid?.transaction_id &&
                                            !selectedTransaction
                                              ?.payment_transaction
                                              ?.transaction_id
                                              ? "border-danger btn form-control dropBtn"
                                              : "btn form-control dropBtn"
                                          }
                                          // className="btn form-control dropBtn"
                                          type="button"
                                          data-bs-toggle="modal"
                                          data-bs-target="#transactionIdmodal"
                                        >
                                          {t("Select a transaction id")}{" "}
                                          <i class="fa-solid fa-angle-down"></i>
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                {requestvalid?.transaction_id &&
                                !selectedTransaction?.payment_transaction
                                  ?.transaction_id &&
                                (createrequst?.category === "Deposits" ||
                                  createrequst?.category === "Withdrawals") ? (
                                  <p className="text-danger">
                                    {requestvalid?.transaction_id}
                                  </p>
                                ) : (
                                  ""
                                )}
                                {selectedTransaction?.payment_transaction
                                  ?.transaction_id && (
                                  <div className="col-lg-6 col-md-6">
                                    <div className="mb-3">
                                      <label>
                                        {createrequst?.category} ID *
                                      </label>
                                      <div className="alertBox d-flex align-items-center">
                                        <div className="alert alert-success pd1214 w-100 mb-0">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="18"
                                            height="18"
                                            fill="rgba(255,255,255,1)"
                                          >
                                            <path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"></path>
                                          </svg>
                                          <p>
                                            {
                                              selectedTransaction
                                                ?.payment_transaction
                                                ?.transaction_id
                                            }{" "}
                                            / {selectedTransaction?.amount} /{" "}
                                            {selectedTransaction
                                              ?.payment_transaction
                                              ?.gateway_name
                                              ? selectedTransaction
                                                  ?.payment_transaction
                                                  ?.gateway_name
                                              : selectedTransaction
                                                  ?.payment_transaction
                                                  ?.payment_name}
                                          </p>
                                        </div>
                                        <div
                                          className="ms-3 closeBtnicon"
                                          onClick={() => {
                                            setSelectedTransaction(null);
                                            setCurrentPage(1);
                                            setSearchdeposit("");
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            width="24"
                                            height="24"
                                            fill="rgba(244,53,53,1)"
                                          >
                                            <path d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"></path>
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="col-lg-12">
                                  <div className="mb-3">
                                    <label>{t("Your message")}*</label>
                                    <textarea
                                      onChange={(e) =>
                                        requestdata("message", e.target.value)
                                      }
                                      value={createrequst?.message}
                                      name="message"
                                      className={
                                        requestvalid?.message
                                          ? "border-danger form-control"
                                          : "form-control"
                                      }
                                      rows="4"
                                      placeholder={t("Enter your message")}
                                      required
                                    ></textarea>
                                    {requestvalid?.message ? (
                                      <p className="text-danger">
                                        {requestvalid?.message}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="mb-3">
                                    <label>{t("Attachment")}</label>
                                    <input
                                      type="file"
                                      name="file"
                                      onChange={(e) => uploadimage(e)}
                                      class="form-control"
                                      ref={fileInputRef}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  {opencount !== null &&
                                  opencount !== undefined ? (
                                    Number(opencount) >= 1 ? (
                                      <div className="alertBox">
                                        <div className="alert alert-danger">
                                          <ul>
                                            <li>
                                              {t("pending_requests_message", {
                                                opencount: opencount,
                                              })}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn bg-white"
                                        onClick={() =>
                                          createrequestvalid(createrequst)
                                        }
                                      >
                                        {t("Submit Request")}
                                      </button>
                                    )
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      state?.from === "faq" ? "show active" : ""
                    }`}
                    id="cashback"
                    role="tabpanel"
                    aria-labelledby="cashback-tab"
                  >
                    <div className="faq_box">
                      <div className="row">
                        <div className="col-12">
                          {" "}
                          <h4 className="card_title">
                            {" "}
                            {t("Frequently Asked Questions")}
                          </h4>
                        </div>
                        {/* <!-- tabs nav --> */}
                        <div className="col-12">
                          <ul
                            className="nav nav-tabs section__tabs"
                            id="section__tabs"
                            role="tablist"
                          >
                            {faqdata?.length
                              ? faqdata.map((result, key) => {
                                  return (
                                    <li
                                      className="nav-item"
                                      role="presentation"
                                      key={key}
                                    >
                                      <button
                                        className={
                                          faqcatagarydata?.key === key
                                            ? "active"
                                            : ""
                                        }
                                        data-bs-toggle="tab"
                                        data-bs-target="#tab-1"
                                        type="button"
                                        role="tab"
                                        aria-controls="tab-1"
                                        aria-selected="true"
                                        onClick={() =>
                                          setFaqcatagarydata({
                                            data: result,
                                            key: key,
                                          })
                                        }
                                      >
                                        {result?.name}
                                      </button>
                                    </li>
                                  );
                                })
                              : ""}
                          </ul>
                        </div>
                        {/* <!-- end tabs nav --> */}

                        {/* <!-- tabs content --> */}
                        <div className="col-12">
                          <div className="tab-content">
                            <div
                              className="tab-pane fade active show"
                              id="tab-1"
                              role="tabpanel"
                            >
                              <div className="row">
                                {/* <!-- accordion --> */}
                                <div className="col-12">
                                  <div className="accordion" id="accordion">
                                    <div className="row">
                                      <div className="col-12 col-lg-12">
                                        <div className="row">
                                          {faqcatagarydata?.data?.[
                                            faqcatagarydata?.data?.name
                                          ]?.length
                                            ? faqcatagarydata?.data?.[
                                                faqcatagarydata?.data?.name
                                              ].map((result, key) => {
                                                return (
                                                  <div className="col-lg-6">
                                                    <div className="accordion__card">
                                                      <button
                                                        className="collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        // data-bs-target="#collapse1"
                                                        aria-expanded="false"
                                                        aria-controls={`collapse${key}`}
                                                        onClick={(e) =>
                                                          handleToggleCollapse(
                                                            `collapse${key}`,
                                                            setCollapseshow,
                                                            true,
                                                            e.currentTarget,
                                                          )
                                                        }
                                                      >
                                                        {result?.title}
                                                      </button>

                                                      <div
                                                        id={`collapse${key}`}
                                                        className="collapse"
                                                        data-bs-parent="#accordion"
                                                      >
                                                        <p>
                                                          {result?.description}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })
                                            : ""}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <!-- end accordion --> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- end tabs content --> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* -----------modal-start----------- */}
        <div
          className="modal fade"
          id="transactionIdmodal"
          tabindex="-1"
          aria-labelledby="transactionIdmodalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h5 className="modal-title mb-3"> {createrequst?.category} </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>

                <div className="searchfillterModal w_form">
                  <input
                    type="search"
                    name="search"
                    value={searchdepodit}
                    onChange={(e) => transactionHistory(e.target.value, 1)}
                    placeholder="Search by Order ID and Method..."
                    className="form-control mb-3"
                  />
                  <ServerDatePicker
                    fetchServerTime={fetchServerTime}
                    onChange={handleDateChange}
                    type={"supportdeshboard"}
                  />
                  <button
                    className="btn form-control justify-content-center"
                    type="button"
                  >
                    <i class="fa-solid fa-search"></i>
                  </button>
                </div>

                <div className="transactionListModal pt-3">
                  {wallethistory?.length
                    ? wallethistory.map((result, key) => {
                        return (
                          <div
                            className="transactionListItem mb-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                              setSelectedTransaction(result);
                              handleCloseModal();
                            }}
                          >
                            <input
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              class="form-radio-input"
                              type="radio"
                              name="radioDefault"
                              id={`radioDefault-${key}`}
                              checked={selectedTransaction?.id === result?.id}
                              onChange={() => {
                                setSelectedTransaction(result);
                                handleCloseModal();
                              }}
                            />
                            <label>
                              {t("Order ID")}:{" "}
                              <strong>
                                {result?.payment_transaction?.transaction_id
                                  ? result?.payment_transaction?.transaction_id
                                  : "-"}
                              </strong>
                            </label>
                            <label>
                              {t("Date")}:{" "}
                              <strong>
                                {
                                  convertLocalToUTCFormatted(
                                    result?.created_at,
                                    updatetimezone,
                                  )?.formatted
                                }
                              </strong>
                            </label>
                            <label>
                              {t("Amount")}:{" "}
                              <strong>
                                ${result?.amount ? result?.amount : "0.00"}
                              </strong>
                            </label>
                            <label>
                              {t("Method")}:{" "}
                              <strong>
                                {result?.payment_transaction?.gateway_name
                                  ? result?.payment_transaction?.gateway_name
                                  : result?.payment_transaction?.payment_name}
                              </strong>
                            </label>
                            <label>
                              {t("Status")}:{" "}
                              {result?.payment_transaction?.payment_status && (
                                <span
                                  className={`status-badge ${
                                    result.payment_transaction.payment_status.toLowerCase() ===
                                    "completed"
                                      ? "status-completed"
                                      : result.payment_transaction.payment_status.toLowerCase() ===
                                          "failed"
                                        ? "status-failed"
                                        : result.payment_transaction.payment_status.toLowerCase() ===
                                            "invalid"
                                          ? "status-invalid"
                                          : result.payment_transaction.payment_status.toLowerCase() ===
                                              "pending"
                                            ? "status-pending"
                                            : result.payment_transaction.payment_status.toLowerCase() ===
                                                "canceled"
                                              ? "status-failed"
                                              : result.payment_transaction.payment_status.toLowerCase() ===
                                                  "underconsideration"
                                                ? "status-underconsideration"
                                                : ""
                                  }`}
                                >
                                  {result.payment_transaction.payment_status.toUpperCase()}
                                </span>
                              )}
                            </label>
                          </div>
                        );
                      })
                    : ""}
                </div>

                <Pagination
                  totalItems={totalPages || 20}
                  itemsPerPage={itemsPerPage || 20}
                  currentPage={currentPage || 1}
                  goToPage={goToPage}
                />
              </div>
            </div>
          </div>
        </div>
        {/* -----------modal-end----------- */}
      </div>
    </React.Fragment>
  );
};

export default Supportdashboard;
